import * as React from "react";
import {TitleProgressProps} from "../../types/types";
import './TitleProgress.scss';
import useBelfiusTheme from "./theme/ThemeHooks";

export const TitleProgress = ( {title, currentStep, maxSteps}: TitleProgressProps ) => {
    let {belfiusThemeState, themeClassName} = useBelfiusTheme();
    const ProgressBar = ( {progressPercentage}: any ) => {
        const width = progressPercentage + "%";

        return (<div className="progress">
            <div className={`progress-bar ${themeClassName}`} role="progressbar" style={{width: width}} aria-valuenow={progressPercentage} aria-valuemin={0} aria-valuemax={100}/>
        </div>)
    };

    const progressPercentage = Math.round( (currentStep / maxSteps) * 100 );
    return (<div className={"mb-5"}>
        {/*<h1 className={themeClassName}><span className={`text-primary mr-2 ${themeClassName}`}>{currentStep}/{maxSteps}</span>{title}</h1>*/}
        <h1 className={themeClassName}>{title}</h1>
        {/*<ProgressBar progressPercentage={progressPercentage}/>*/}
    </div>)
};
